import React from "react";
import { MessageCircle } from "lucide-react";

const FloatingWhatsAppButton = () => {
  const whatsappUrl = "https://wa.me/917014581250?text=Hi%2C%20I%20would%20like%20to%20connect%20with%20you%20regarding%20wool%20sourcing%20and%20supply";

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-4 right-4 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-500/30 transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-emerald-300/50"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
};

export default FloatingWhatsAppButton;
